'use strict';

module.exports.paymentTypes = ['cancellation refund', 'cancellation charge', 'reconciliation refund'];